import { render, staticRenderFns } from "./supplierEdit.vue?vue&type=template&id=35575d36&"
import script from "./supplierEdit.vue?vue&type=script&lang=js&"
export * from "./supplierEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports